/*
 * MYHOLDAL breadcrumbs - session trail (Sep 2026).
 *
 * Replaces the Liquid baseline trail with the steps the shopper actually took,
 * e.g. Home > Derma > La Roche-Posay > Product. Stored per tab in
 * sessionStorage; falls back to the baseline whenever the trail can't be
 * trusted (new tab, arrived from Google, header / footer / drawer navigation).
 *
 * The trail only grows when the shopper clicked a link inside the page content
 * (#MainContent) or a crumb. Anything else - menus, logo, the Boost search
 * popup (rendered outside the header), typed URLs - starts a new trail.
 * (Oct 2026: search results used to stack, e.g. Home > Brand A > Brand B.)
 *
 * Rules when moving forward by an in-page link:
 *  - page (1) < collection (2) < product (3): anything deeper than the new
 *    page is dropped, so Collection > Product > (back to) Collection never
 *    stacks.
 *  - Product -> product (recommendations) replaces the product.
 *  - Revisiting a URL already in the trail (Back button, clicking a crumb)
 *    cuts the trail back to it.
 *  - At most MAX crumbs between Home and the current page.
 */
(function () {
  var nav = document.querySelector('[data-mh-bc]');
  if (!nav) return;

  var KEY = 'mhBcTrail:v1';
  var STEP = 'mhBcStep:v2';
  var BY_URL = 'mhBcByUrl:v1';
  var NAV = 'mhBcNav:v1';
  var MAX = 3;
  var RANK = { page: 1, blog: 1, search: 1, 'list-collections': 1, collection: 2, article: 2, product: 3 };

  function norm(path) {
    // Boost opens /products/x as /collections/<any>/products/x - same page.
    path = (path || '/').replace(/\/collections\/[^\/]+(\/products\/)/, '$1').replace(/\/+$/, '');
    return path || '/';
  }
  function rank(kind) { return RANK[kind] || 1; }
  function store(key, val) {
    try {
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }
  function load(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  var current = { u: norm(location.pathname), t: nav.getAttribute('data-title'), k: nav.getAttribute('data-kind') };

  // Baseline from Liquid: every link except Home, then the current page.
  var baseline = [];
  var links = nav.querySelectorAll('.mh-bc__link');
  for (var i = 1; i < links.length; i++) {
    baseline.push({ u: norm(links[i].pathname), t: links[i].textContent.trim(), k: links[i].getAttribute('data-kind') || 'page' });
  }
  baseline.push(current);

  var referrer = null;
  try {
    var r = new URL(document.referrer);
    if (r.origin === location.origin) referrer = norm(r.pathname);
  } catch (e) {}

  // How we got here: { u: clicked path, src: 'content' | 'crumb' }, or null.
  var step = load(STEP);
  store(STEP, null);
  if (!step || step.u !== current.u) step = null;

  var saved = load(KEY);
  var trail = Array.isArray(saved) ? saved : [];
  var at = -1;
  for (var j = 0; j < trail.length; j++) if (trail[j].u === current.u) { at = j; }

  // Back / Forward: show the trail this page had when it was last seen.
  var byUrl = load(BY_URL) || {};
  var navType = '';
  try { navType = performance.getEntriesByType('navigation')[0].type; } catch (e) {}

  if ((navType === 'back_forward' || navType === 'reload') && Array.isArray(byUrl[current.u])) {
    trail = byUrl[current.u];
  } else if (!step) {
    // Menu, logo, search popup, typed URL...: a new journey starts here.
    trail = baseline;
  } else if (at >= 0) {
    trail = trail.slice(0, at);
    trail.push(current);
  } else if (step.src === 'content' && referrer && trail.length && trail[trail.length - 1].u === referrer) {
    while (trail.length) {
      var last = trail[trail.length - 1];
      if (rank(last.k) > rank(current.k) || (last.k === 'product' && current.k === 'product')) trail.pop();
      else break;
    }
    trail.push(current);
  } else {
    trail = baseline;
  }

  if (trail.length > MAX + 1) trail = trail.slice(trail.length - (MAX + 1));
  store(KEY, trail);
  delete byUrl[current.u];
  byUrl[current.u] = trail;
  var keys = Object.keys(byUrl);
  while (keys.length > 40) delete byUrl[keys.shift()];
  store(BY_URL, byUrl);

  // Restored from the back/forward cache: the DOM is already right, but the
  // stored trail must follow this page again.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) store(KEY, trail);
  });

  // Only rebuild when the trail differs from what Liquid printed.
  var same = trail.length === baseline.length && trail.every(function (c, n) { return c.u === baseline[n].u; });
  if (!same) {
    var list = nav.querySelector('.mh-bc__list');
    var currentItem = list.lastElementChild;
    // keep Home (first) and the current page (last), replace what is between
    while (list.children.length > 2) list.removeChild(list.children[1]);
    trail.slice(0, -1).forEach(function (c) {
      var li = document.createElement('li');
      li.className = 'mh-bc__item';
      var a = document.createElement('a');
      a.className = 'mh-bc__link';
      a.href = c.u;
      a.setAttribute('data-kind', c.k);
      a.textContent = c.t;
      li.appendChild(a);
      list.insertBefore(li, currentItem);
    });
  }

  // Phones: the list scrolls sideways - keep the current page in view.
  var ol = nav.querySelector('.mh-bc__list');
  if (ol.scrollWidth > ol.clientWidth) ol.scrollLeft = ol.scrollWidth;

  // Header category row (BRANDS, CLOTHING...): underline the one this journey
  // belongs to. 1) the category clicked to start the journey, 2) else the
  // deepest trail page that one of the menus links to, 3) else Liquid's guess.
  function navToken(li) {
    for (var c = 0; c < li.classList.length; c++) {
      if (li.classList[c].indexOf('site-nav__item-') === 0) return li.classList[c];
    }
    return null;
  }
  var navItems = [].slice.call(document.querySelectorAll('.site-navigation > .site-nav__item:not(.main-menu)'));
  if (navItems.length) {
    var pick = null;
    var navState = load(NAV);
    var inTrail = function (u) { return trail.some(function (c) { return c.u === u; }); };
    if (navState && navState.t && inTrail(navState.u)) pick = navState.t;
    for (var d = trail.length - 1; d >= 0 && !pick; d--) {
      for (var m = 0; m < navItems.length && !pick; m++) {
        var li = navItems[m];
        var hrefs = [].slice.call(li.querySelectorAll('a[href]')).map(function (x) { return norm(x.pathname); });
        var sum = li.querySelector('summary[data-link]');
        if (sum) hrefs.push(norm(sum.getAttribute('data-link')));
        if (hrefs.indexOf(trail[d].u) >= 0) pick = navToken(li);
      }
    }
    if (pick) {
      navItems.forEach(function (li) { li.classList.toggle('mh-nav-active', navToken(li) === pick); });
    }
  }

  // Remember where each click came from; read on the next page load.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // Megamenu titles (CLOTHING...) are <summary data-link>, which the theme
    // turns into a navigation on click.
    var a = e.target.closest('a[href], summary[data-link]');
    if (!a) return;
    var path;
    try { path = norm(new URL(a.getAttribute('href') || a.getAttribute('data-link'), location.href).pathname); } catch (err) { return; }
    if (a.href && a.origin !== location.origin) return;
    if (a.closest('.mh-bc')) {
      store(STEP, { u: path, src: 'crumb' });
    } else if (a.closest('#MainContent') && !a.closest('#bc-instant-search, .boost-sd__instant-search-container, .boost-sd__search-bar-wrapper')) {
      store(STEP, { u: path, src: 'content' });
    } else {
      store(STEP, null);
      var item = a.closest('.site-navigation > .site-nav__item:not(.main-menu)');
      store(NAV, item ? { t: navToken(item), u: path } : null);
    }
  }, true);
})();
